export const isMobileSafari = () => {
  if (!window) {
    return false;
  }

  // https://stackoverflow.com/a/29696509
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);

  // If iOS Chrome needs to be separated, use `!ua.match(/CriOS/i)` as
  // an extra condition.
  return iOS && webkit;
};

export const checkUserAgent = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  // Opera 8.0+
  const isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

  if (isOpera) {
    return 'opera';
  }

  // Firefox 1.0+
  const isFirefox = typeof InstallTrigger !== 'undefined';

  if (isFirefox) {
    return 'firefox';
  }

  // Safari 3.0+ "[object HTMLElementConstructor]" 
  const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification));

  if (isSafari) {
    return 'safari';
  }

  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/false || !!document.documentMode;

  if (isIE) {
    return 'IE';
  }

  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;

  if (isEdge) {
    return 'edge';
  }

  // Chrome 1 - 79
  const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  if (isChrome) {
    return 'chrome';
  }

  // Edge (based on chromium) detection
  const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") !== -1);

  if (isEdgeChromium) {
    return 'edgeChromium';
  }

  return null;
}